<template>
    <div class="game-info-wrapper">
        <div class="r-l game-name" @click="showAllGames">
            {{ gameName }}
            <i class="i-game-arrow" :class="{ on: isShowAllGames }"></i>
            <div class="game-list-box">
                <Search
                    v-if="false"
                    v-show="isShowAllGames"
                    :placeholder="palceHolder"
                    @searchChange="searchChange"
                    @inputChange="searchChange"
                    class="game-search"
                />
                <PopupMenu
                    :class="{ 'show-popup': isShowAllGames }"
                    :menus="allGames"
                    :isShow="isShowAllGames"
                    :position="{ topOrBottom: 45 }"
                    class="game-list"
                    @menuChange="selectGame"
                    :noMemory="true"
                ></PopupMenu>
            </div>
        </div>
    </div>
</template>

<script>
import PopupMenu from "@/views/zhiji/bComponents/popupMenu/PopupMenu";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";

export default {
    name: "GameInfo",
    components: {
        PopupMenu,
        Search
    },
    data() {
        return {
            isShowAllGames: false
        };
    },
    computed: {
        palceHolder() {
            return this.$t("zhiji.game.searchGame");
        },
        gameName() {
            let gameId = this.getStorePorp("gameId");
            let gameData = this.allGames.find(item => item.value == gameId);
            return gameData ? gameData.label : "";
        },
        allGames() {
            const robots = this.$store.state.auth.businessSetting.robots || [];

            // pubg保持原来的逻辑不变
            if (isPubg()) {
                return [
                    {
                        value: 88888,
                        label: `${this.$t("zhiji.game.basicServices")} (88888)`,
                    },
                    {
                        value: 80001,
                        label: `${this.$t("zhiji.game.securityBase")} (80001)`,
                    },
                    {
                        value: 80002,
                        label: `${this.$t("zhiji.game.contentBase")} (80002)`,
                    }
                ];
            }

            return robots.map(robot => {
                return {
                    value: robot.gameId,
                    label: `${robot.robotName} (${robot.gameId})`
                };
            });
        }
    },
    methods: {
        searchChange() {
            // TODO
        },
        showAllGames() {
            this.isShowAllGames = !this.isShowAllGames;
        },
        selectGame(data) {
            if (data.label === this.gameName) {
                return;
            }
            let gameInfo = {
                gameId: data.value,
                gameName: data.label
            };
            this.$store.commit("zhiji/switchCurrentGame", gameInfo);
        },
        hideAllGames() {
            this.isShowAllGames = false;
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.gameState[propName];
        },
        windowClick(event) {
            if (this.isShowAllGames && this.zhiji.isClickOuter(event, "game-info-wrapper")) {
                this.isShowAllGames = false;
            }
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};
</script>

<style lang="less" scoped>
.game-info-wrapper {
    position: relative;
    text-align: right;
    .game-name {
        position: relative;
        z-index: 1;
        font-weight: normal;
        white-space: nowrap;
        cursor: pointer;

        .i-game-arrow {
            display: inline-block;
            width: 12px;
            height: 8px;
            margin-left: 7px;
            background: url("@{zhijiStaticImagePath}header-spr.png") -27px -19px;
            &.on {
                transform: rotate(180deg);
                transition: transform 0.2s ease-in-out;
            }
        }
        .game-list {
            width: 100%;
            font-size: 12px;
            max-height: 360px;
            overflow-y: auto;
        }

        .game-list-box {
            width: 100%;
            position: relative;
            margin-top: -35px;

            .game-search {
                width: 100%;
                font-size: 14px;
                background: #fff;
            }
        }
    }

    .show-popup {
        display: block !important;
    }
}
</style>
